import { useState } from "react";

import {
  Flex,
  Input,
  Menu,
  MenuButton,
  MenuList,
  Switch,
  Text,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";

import HideIconSvg from "@/assets/svg/hide-icon.svg";
import { useActions } from "@/hooks/useActions";
import newViewSelectors from "@/store/newView/newView.selectors";
import { thinkScrollbar } from "@/utils/thinkScrollbar";

import { listFields } from "../../../data/lists";
import PreferenceButton from "../../shared/PreferenceButton";
import ViewPreferenceItem from "../../shared/ViewPreferenceItem";

import HideButtons from "./HideButtons";
// import newCompaniesListSelectors from "@/store/newCompaniesList/newCompaniesList.selectors";

const HideColumnMenu = () => {
  const fields = listFields?.slice(1);
  const [searchColumn, setSearchColumn] = useState("");
  const {
    setToggleColumnsField,
    setHideAllColumns,
    setShowAllColumns,
    setViewParams,
  } = useActions();

  const filteredFields = fields?.filter((fld) =>
    fld?.title?.toLowerCase()?.includes(searchColumn?.toLowerCase())
  );
  const currentView = useSelector(newViewSelectors.getCurrentView());
  const currentParams = useSelector(newViewSelectors.getViewParams());
  const viewColumns = currentParams?.[currentView?.id]?.columns;

  const hidenColumnsCount = fields?.length - viewColumns?.length;
  const buttonTitle = !hidenColumnsCount
    ? "Columns"
    : hidenColumnsCount > 1
    ? `${hidenColumnsCount} hidden columns`
    : `${hidenColumnsCount} hidden column`;

  const onToggleColumnHandler = (fld) => {
    const columns = viewColumns?.includes(fld)
      ? viewColumns?.filter((clmn) => clmn !== fld)
      : [...viewColumns, fld];
    setToggleColumnsField(fld);
    setViewParams({
      key: currentView?.id,
      params: {
        columns,
      },
    });
  };

  const onHideAllHandler = () => {
    setHideAllColumns();
    setViewParams({
      key: currentView?.id,
      params: {
        columns: [],
      },
    });
  };

  const onShowAllHandler = () => {
    setShowAllColumns();
    setViewParams({
      key: currentView?.id,
      params: {
        columns: fields?.map((f) => f?.id),
      },
    });
  };

  const onCloseHandler = () => {
    onShowAllHandler();
  };

  const handlers = {
    showAll: onShowAllHandler,
    hideAll: onHideAllHandler,
  };

  return (
    <Menu>
      {({ isOpen }) => (
        <>
          <PreferenceButton
            color={"lightPurple"}
            isActive={isOpen || hidenColumnsCount}
            isClose={hidenColumnsCount}
            closeHandler={onCloseHandler}
          >
            <MenuButton>
              <ViewPreferenceItem title={buttonTitle} icon={HideIconSvg} />
            </MenuButton>
          </PreferenceButton>
          <MenuList zIndex={"30"} p={"12px"}>
            <Flex direction={"column"} rowGap={"12px"}>
              <Input
                variant={"unstyled"}
                borderWidth={"1px"}
                borderColor={"lightGray"}
                px={"12px"}
                fontSize={"12px"}
                fontWeight={"400"}
                lineHeight={"1"}
                letterSpacing={"4%"}
                h={"34px"}
                maxW={"220px"}
                placeholder="Search fields..."
                _placeholder={{ fontSize: "12px" }}
                value={searchColumn || ""}
                onChange={(e) => setSearchColumn(e.target.value)}
              />

              <Flex
                direction={"column"}
                maxH={"162px"}
                overflow={"auto"}
                sx={{ ...thinkScrollbar }}
              >
                {filteredFields?.map((item, idx) => (
                  <Flex
                    key={item?.id + idx}
                    align={"center"}
                    columnGap={"10px"}
                    w={"100%"}
                    h={"27px"}
                  >
                    <Switch
                      variant={"show"}
                      isChecked={viewColumns?.includes(item?.id)}
                      onChange={() => onToggleColumnHandler(item?.id)}
                    />
                    <Text
                      fontSize={"14px"}
                      fontWeight={"400"}
                      lineHeight={"1.35"}
                      letterSpacing={"2%"}
                    >
                      {item?.title}
                    </Text>
                  </Flex>
                ))}
              </Flex>

              <HideButtons handlers={handlers} />
            </Flex>
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default HideColumnMenu;
